export default __webpack_public_path__ + "static/media/BannersWeb_PostHotsale_GMM_330x330.0b2b7096.jpg";